
  import {Component, Prop, Vue} from "vue-property-decorator";
  import {AntiTheftActions} from "@/modules/CarList/mixins/anti-theft-actions.mixin";
  import {IAntiTheft} from "@/modules/CarList/interfaces/anti-theft.interface";
  import {antiTheftCars} from "@/modules/CarList/mixins/antitheft.class";
  import {bus} from "@/plugins/bus";

  @Component({})
  export default class AntiTheftBtn extends Vue {
    @Prop() mainMenu!: boolean;
    @Prop() homeMode!: boolean;
    @Prop() mobileNavigation!: boolean;

    securityActive = false;
    cars: IAntiTheft.IStatusCars[] = [];

    async mounted () {
      this.presetData();

      bus.$on(IAntiTheft.BusEvents.GetCars, this.presetData);
      bus.$on(IAntiTheft.BusEvents.UpdateSecurity, () => this.securityActive = antiTheftCars.securityActive);
    }

    async presetData() {
      this.cars = antiTheftCars.cars;
      this.securityActive = antiTheftCars.securityActive;
    }

    async clickOnBtn() {
      await antiTheftCars.getAntiTheftInfo(this);
      this.presetData();

      if (this.cars && this.cars.length > 1) {
        this.openPopup();
      }
      else if (this.cars && this.cars.length === 1) {
        this.securityActive = this.cars[0].theftFlag;
        this.toggleSecurity();
      }
    }

    async toggleSecurity() {
      antiTheftCars.updateSecurity(!this.securityActive);

      await AntiTheftActions.changeStatus(this, {
        carId: this.cars[0].carId,
        securityActive: this.securityActive,
        scheduleActive: this.cars[0].theftScheduleFlag,
      });

      this.$notify({
        title: this.securityActive ? 'Поставлен на охрану' : 'Снят с охраны',
        message: 'Вы можете задать расписание в карточке автомобиля.',
        type: 'success'
      });
    }

    async openPopup() {
      await this.$store.dispatch('dialog/openDialog', { blockName: 'allPages', dialogName: 'antiTheftCars', payload: { cars: this.cars } });
    }
  }
